import RestoreForm from 'forms/RestoreForm'
import { useInfoProviderContext } from 'utils/providers/InfoProvider/InfoProviderContext'

import { useTranslation } from 'next-i18next'
import { serverSideTranslations } from 'next-i18next/serverSideTranslations'
import dynamic from 'next/dynamic'
import Head from 'next/head'

import AuthLayout from 'layouts/AuthLayout'

import Link from 'components/Link'
import StructuredData from 'components/StructuredData/StructuredData'
import Typography from 'components/Typography'

import styles from './restore.module.scss'

const DynamicRestrictedModal = dynamic(() => import('components/RestrictedModal'))

const RestorePage = ({ referrer, ssrHost }) => {
  const [t] = useTranslation(['main', 'contacts'])

  const info = useInfoProviderContext()

  if (info?.restricted === true) {
    return <DynamicRestrictedModal />
  }

  return (
    <>
      <StructuredData host={ssrHost} variant="base" path="/auth/recovery" />
      <Head>
        <title>Restore password | Binany</title>
        <meta name="description" content="Restore password" />

        <meta property="og:title" content="Restore password | Binany" />
        <meta property="og:description" content="Restore password" />
        <meta property="og:image" content="https://binany.com/images/logoWhite.svg" />
        <meta property="og:site_name" content="Binany - Online Platform for Trading" />
        <meta property="og:type" content="article" />
      </Head>

      <AuthLayout>
        <div className={styles.grid}>
          <Typography variant="h4" className={styles.header}>
            {t('main:recoveryPassRecovery')}
          </Typography>

          <RestoreForm referrer={referrer} />

          <div className={styles.additional}>
            <div className={styles.back}>
              <Link href="/auth/signin" id="recovery-form-login-link" className={styles.backLink}>
                {t('main:recoveryBackSignIn')}
              </Link>
            </div>
            <div className={styles.register}>
              <span>{t('main:authDontHaveAcc')}</span>
              <Link
                href="/auth/signup?from=recoveryPage"
                as="/auth/signup"
                id="recovery-form-register-link"
                className={styles.link}
              >
                {t('main:recoverySignUpHere')}
              </Link>
            </div>
          </div>
        </div>
      </AuthLayout>
    </>
  )
}

export default RestorePage

export async function getServerSideProps({ locale, req }) {
  return {
    props: {
      ssrHost: req.headers.host || '',
      ...(await serverSideTranslations(locale, ['main', 'contacts', 'shared', 'error'])),
    },
  }
}
